"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STUDENT_IDENTIFICATION_NUMBER = void 0;
var entities_1 = require("@common/entities");
var DONT_HAVE_FIELD_NAME_1 = require("./DONT_HAVE_FIELD_NAME");
exports.STUDENT_IDENTIFICATION_NUMBER = {
    name: 'student_identification_number',
    label: 'Student Identification Number',
    customType: entities_1.IDTypes.StudentIdentificationNumber,
    elementType: entities_1.SectionElementType.Block,
    fields: [
        {
            customType: entities_1.FieldType.Text,
            enabled: true,
            label: 'Student Identification Number',
            name: entities_1.IdTypeFields.value.name,
            required: false,
            sequence: 1,
            type: entities_1.FieldType.Text,
        },
        {
            customType: entities_1.FieldType.Checkbox,
            enabled: false,
            label: "I don't have a Student Identification Number.",
            name: DONT_HAVE_FIELD_NAME_1.ID_TYPE_DONT_HAVE_FIELD_NAME_MAPPING[entities_1.IDTypes.StudentIdentificationNumber],
            required: false,
            sequence: 5,
            type: entities_1.FieldType.Checkbox,
        },
    ],
};
